import { ActionCreator, combineReducers, compose } from 'redux';
import { ThunkAction, thunk } from 'redux-thunk';
import { modalReducer } from './reducers/set-modal';
import { configureStore } from '@reduxjs/toolkit';
import appReducer from './app.slice';
import userInfoReducer from './user';
import referalsReducer from './referals';
import tasksReducer from './tasks/';
import drawsReducer from './draws/';
import workReducer from './work/';
import assetsReducer from './assets/';
import collectionsReducer from './collections/';
import challengesSlice from './challenges/';
import achievementsReducer from './achievements/';
import boostsReducer from './boosts/';
import ratingsReducer from './ratings/';
import profileReducer from './profile/';
import quizReducer from './quizzes/';
import businessesReducer from './businesses/';
import actionPromptsReducer from './action-prompts/';
import notificationsReducer from './notifications/';
import debugReducer from './debug/';
import uiReducer from './ui/';
import { gamesReducer } from './games';
import { Api } from '../api/api';
import { fragmentsMiddleware } from './draws/fragments.middleware';

export const rootReducer = combineReducers({
    appData: appReducer,
    modal: modalReducer,

    user: combineReducers({
        info: userInfoReducer,
        profile: profileReducer,
    }),

    referals: referalsReducer,
    work: workReducer,
    notifications: notificationsReducer,
    tasks: tasksReducer,
    draws: drawsReducer,

    assets: assetsReducer,
    collections: collectionsReducer,
    achievements: achievementsReducer,
    challenges: challengesSlice,
    boosts: boostsReducer,
    rating: ratingsReducer,
    quiz: quizReducer,
    businesses: businessesReducer,
    actionPrompts: actionPromptsReducer,
    ui: uiReducer,

    debug: debugReducer,

    games: gamesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

declare global {
    interface Window {
      __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk, fragmentsMiddleware),
    devTools: process.env.ENV !== 'PROD',
});

export type TStore = ReturnType<typeof rootReducer>;

type TApplicationActions = any;

export type AppThunk<TReturn = void> = ActionCreator<ThunkAction<TReturn, TStore, unknown, TApplicationActions> >;

export type AppDispatch = typeof store.dispatch;
Api.store = store;